import { Component, Input } from '@angular/core';


@Component({
  selector: 'rr-track-header',
  standalone: false,
  templateUrl: './track-header.component.html',
  styleUrl: './track-header.component.scss'
})
export class TrackHeaderComponent {

  @Input() trackName: string = ""
  @Input() trackType: string = ""

}
